import type { ProjectShortcut } from '@atlassian/jira-navigation-apps-resources/src/types.tsx';
import type { NavLink } from '@atlassian/jira-navigation-types/src/types.tsx';

const getShortcutIcon = (type: string): string => {
	if (type == null || type === 'unknown' || type === 'unsupported') {
		return 'shortcut';
	}
	if (type === 'github') {
		return 'repos';
	}
	return type;
};

export const transformShortcuts = (
	arrayOfShortcuts: ProjectShortcut[],
	canEditOld: boolean,
): NavLink[] => {
	if (arrayOfShortcuts && Array.isArray(arrayOfShortcuts)) {
		const links: NavLink[] = [];
		const repos: NavLink[] = [];

		arrayOfShortcuts.forEach((shortcut) => {
			const shortcutIcon = getShortcutIcon(shortcut.dvcsType);
			const s = {
				id:
					shortcut.type == null
						? `com.atlassian.jira.jira-projects-plugin:project.shortcut.default.link.${shortcut.id}`
						: `com.atlassian.jira.jira-projects-plugin:${shortcut.type}.${shortcut.id}`,
				name: shortcut.name,
				icon: shortcutIcon,
				url: shortcut.url,
				selected: false,
				section: false,
				separator: false,
				showDot: false,
				hasLandingPage: false,
				canEdit: canEditOld, // - pass in info from old items for now
				showSync: false,
				canDismiss: false,
				sortable: false,
				target: '_blank',
			};
			shortcut.type === 'source.code.link' ? repos.push(s) : links.push(s);
		});

		return repos.concat(links);
	}
	return [];
};
